import {
  UpdateCustomerNotificationInput,
  UpdateCustomerNotificationsSettingsInput,
} from "shared";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

//---------------------------NEW APIs-------------------------------------//
export const getCustomerNotificationsSettings = async (customerId: string) => {
  try {
    const url = `/v2/customers/notifications/${customerId}`;
    const response = await axiosClient.get(`${url}`);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const updateCustomerNotificationsSettings = async ({
  data,
  notificationType,
  customerId,
}: UpdateCustomerNotificationsSettingsInput) => {
  try {
    const url = `/v2/customer/${customerId}/notififcation/notify_type/${notificationType}`;
    const response = await axiosClient.patch(`${url}`, data);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const resetCustomerNotificationsSettings = async (
  customerId: string
) => {
  try {
    const url = `/v1/customer/${customerId}/notififcation/reset`;
    const response = await axiosClient.patch(`${url}`);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
//---------------------------NEW APIs-------------------------------------//

//---------------------------OLD DEPRECATED APIs-------------------------------------//
export const getCustomerNotificationSettings = async (customerId: string) => {
  try {
    const url = `/customers/notifications/${customerId}`;

    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const updateCustomerNotificationSettings = async ({
  notificationType,
  notificationSound,
  notificationStatus,
  notifyMethods,
  notifyRoles,
  customerId,
}: UpdateCustomerNotificationInput) => {
  try {
    const url = `/update/customer/${customerId}/notififcation/notify_type/${notificationType}`;

    const data = {
      notification_status: notificationStatus,
      notification_sound: notificationSound,
      notify_roles: notifyRoles,
      notify_methods: notifyMethods,
    };
    const response = await axiosClient.patch(`${url}`, data);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};
//---------------------------OLD DEPRECATED APIs-------------------------------------//
